import i18n from 'sveltekit-i18n';
import { get, writable } from 'svelte/store';
import lang from './lang.json';

import fr_home from './fr/home.json';
import en_home from './en/home.json';

import fr_clients from './fr/clients.json';
import en_clients from './en/clients.json';

import fr_dates from './fr/dates.json';
import en_dates from './en/dates.json';

import fr_shared from './fr/shared.json';
import en_shared from './en/shared.json';

import fr_groups_booking_module from './fr/gbm.json';
import en_groups_booking_module from './en/gbm.json';

import fr_noshow from './fr/noshow.json';
import fr_settings from './fr/settings.json';
import fr_menu from './fr/menu.json';
import fr_groups from './fr/groups.json';
import fr_database from './fr/database.json';
import fr_groups_website from './fr/groups-website.json';
import fr_phone from './fr/phone.json';
import fr_tm from './fr/tm.json';
import fr_team from './fr/team.json';
import fr_bsms from './fr/backoffice_sms.json';
import fr_mycard from './fr/mycard.json';
import fr_contact from './fr/contact.json';
import fr_bookings from './fr/bookings.json';
import fr_orders from './fr/orders.json';
import fr_jobs from './fr/jobs.json';
import fr_ohg from './fr/ohg.json';
import fr_configurationmessages from './fr/configuration-messages.json';
import fr_qrcode from './fr/qrcode.json';
import fr_invoice from './fr/invoice.json';
import fr_reviews from './fr/reviews.json';
import fr_mangeznotez_sheet from './fr/mangeznotez-sheet.json';
import fr_dashboard from './fr/dashboard.json';
import fr_stats from './fr/stats.json';
import fr_op from './fr/op.json';
import fr_sponsorship from './fr/sponsorship.json';
import fr_invoices_admin from './fr/invoices-admin.json';
import fr_stripe from './fr/stripe.json';
import fr_cac from './fr/click_and_collect.json';
import fr_delivery from './fr/delivery.json';
import fr_giftcards from './fr/gc.json';
import fr_debits from './fr/debits.json';
import fr_admin from './fr/admin.json';
import fr_news from './fr/news.json';
import fr_newMobile from './fr/new-mobile.json';
import fr_booking_module from './fr/booking-module.json';
import fr_collectRestInfo from './fr/cri.json';
import fr_admin_chat from './fr/admin-chat.json';
import fr_mobile_menu from './fr/mobile-menu.json';
import fr_hub from './fr/hub.json';
import fr_redirect from './fr/redirect.json';

import en_groups from './en/gbm.json';

/** @type {import('sveltekit-i18n').Config} */

const SETTINGS_PATH = /\/v2\/backoffice\/mon-gestionnaire-de-tables\/parametres[\/\w_.-]*/gms;
const RESTAURANT_INFO_PATH = /\/v2\/collecte-info-restaurant[\/\w_.-]*/gms;
const COLLECT_REST_PICTURES = /\/v2\/collecte-photos[\/\w_.-]*/gms;
const HUB_AFTER_SALES = /\/v2\/hub-after-sales[\/\w_.-]*/gms;
const AI_GENERATE_TEXT = /\/v2\/ai-generate-text[\/\w_.-]*/gms;
const TABLES_MANAGEMENT_PATH = /\/v2\/backoffice\/ma-salle[\/\w_.-]*/gms;
const GROUPS_MANAGEMENT_PATH =
	/\/v2\/backoffice\/mon-gestionnaire-de-groupes[\/\w_.-]*|\/v2\/admin\/groupes*/gms;
const BACKOFFICE_PATH = /\/v2\/backoffice[\/\w_.-]*/gms;
const CLIENTS_PATH = /\/v2\/backoffice\/mon-restaurant\/clients[\/\w_.-]*/gms;
const MY_TEAM_PATH = /\/v2\/backoffice\/mon-restaurant\/mon-equipe[\/\w_.-]*/gms;
const MY_CARD_PATH = /\/v2\/backoffice\/mon-restaurant\/ma-carte[\/\w_.-]*/gms;
const CARD_GENERATOR_PATH = /\/v2\/backoffice\/mon-restaurant\/generateur-de-carte[\/\w_.-]*/gms;
const JOBS_PATH = /\/v2\/backoffice\/mon-restaurant\/mes-candidatures[\/\w_.-]*/gms;
const MY_SMS_PATH = /\/v2\/backoffice\/mon-restaurant\/mes-sms[\/\w_.-]*/gms;
const MY_SCHEDULE_PATH = /\/v2\/backoffice\/mon-restaurant\/mes-horaires[\/\w_.-]*/gms;
const MY_BOOKINGS_PATH = /\/v2\/backoffice\/mes-reservations[\/\w_.-]*/gms;
const DASHBOARD_PATH = /\/v2\/backoffice\/dashboard[\/\w_.-]*/gms;
const STATS_PATH = /\/v2\/backoffice\/rapports\/statistique[\/\w_.-]*/gms;
const CALENDAR_PATH = /\/v2\/backoffice\/calendrier[\/\w_.-]*/gms;

const MY_ORDERS_PATH = /\/v2\/(backoffice\/mes-commandes|livraison-emporter)[\/\w_.-]*/gms;

const NEWS_PATH = /\/v2\/backoffice\/mes-actualites[\/\w_.-]*/gms;
const CONFIGURATION_MESSAGES_PATH =
	/\/v2\/backoffice\/mon-restaurant\/configuration-messages[\/\w_.-]*/gms;
const MY_QRCODE_PATH = /\/v2\/backoffice\/mon-restaurant\/mes-qrcodes[\/\w_.-]*/gms;
const MY_INVOICES_PATH = /\/v2\/backoffice\/mon-compte\/mes-finances[\/\w_.-]*/gms;
const MY_REVIEWS_PATH = /\/v2\/backoffice\/rapports\/mes-avis[\/\w_.-]*/gms;
const MY_SHEET_PATH = /\/v2\/backoffice\/mon-restaurant\/ma-fiche[\/\w_.-]*/gms;
const NEW_MOBILE_PATH = /\/v2\/backoffice\/new-mobile[\/\w_.-]*/gms;
const ONLINE_PAYMENTS_PATH = /\/v2\/backoffice\/mon-compte\/paiement-en-ligne[\/\w_.-]*/gms;
const SPONSORSHIP_PATH = /\/v2\/admin\/parrainage[\/\w_.-]*/gms;
const MY_GIFTCARDS_PATH = /\/v2\/backoffice\/mes-cartes-cadeaux[\/\w_.-]*/gms;
const ADMIN_INVOICES_PATH = /\/v2\/admin\/factures[\/\w_.-]*/gms;
const ADMIN_DEBITS_PATH = /\/v2\/admin\/prelevements[\/\w_.-]*/gms;
const ADMIN_DEBITS_STATES_PATH = /\/v2\/admin\/etat-prelevement[\/\w_.-]*/gms;
const ADMIN_CHAT_PATH = /\/v2\/admin\/chat[\/\w_.-]*/gms;
const ADMIN_PATH = /\/v2\/admin[\/\w_.-]*/gms;
const CLICK_AND_COLLECT_PATH = /\/v2\/livraison-emporter[\/\w_.-]*/gms;
const DELIVERY_PATH =
	/\/v2\/backoffice\/mon-restaurant\/configuration-livraison-emporter[\/\w_.-]*/gms;
const BOOKING_MODULE_PATH = /\/v2\/reservation[\/\w_.-]*/gms;
const ALL = /[\/\w_.-]*/gms;

// FIXME: this should be handled in the config below.
// doing so without the actual translations will show the keys instead of the translations
// TODO: 1) translate EVERYTHING into english
//       2) set config.config.fallbackLocale to 'en'
//       3) remove this line and every other line that uses TEMPORARY_FALLBACK_LOCALE
export const TEMPORARY_FALLBACK_LOCALE = 'fr';

export const config = {
	translations: {
		en: { lang },
		fr: { lang }
	},
	fallbackLocale: 'fr',
	loaders: [
		{
			locale: 'fr',
			key: 'home',
			routes: [ALL],
			//  for informational purposes, the async import above was replaced by a static import
			// loader: async () => (await import('./fr/home.json')).default
			loader: () => fr_home
		},
		{
			locale: 'fr',
			key: 'stripe',
			routes: [ALL],
			loader: () => fr_stripe
		},
		{
			locale: 'en',
			key: 'home',
			routes: [ALL],
			loader: () => en_home
		},
		{
			locale: 'fr',
			key: 'contact',
			routes: [BACKOFFICE_PATH],
			loader: () => fr_contact
		},
		{
			locale: 'fr',
			key: 'shared',
			routes: [ALL],
			loader: () => fr_shared
		},
		{
			locale: 'en',
			key: 'shared',
			routes: [ALL],
			loader: () => en_shared
		},
		{
			locale: 'fr',
			key: 'noshow',
			routes: [ALL],
			loader: () => fr_noshow
		},
		{
			locale: 'fr',
			key: 'tm',
			routes: [TABLES_MANAGEMENT_PATH, ALL],
			loader: () => fr_tm
		},
		{
			locale: 'fr',
			key: 'stgs',
			routes: [ALL],
			loader: () => fr_settings
		},
		{
			locale: 'fr',
			key: 'phone',
			routes: [ALL],
			loader: () => fr_phone
		},
		{
			locale: 'fr',
			key: 'dates',
			routes: [ALL],
			loader: () => fr_dates
		},
		{
			locale: 'en',
			key: 'dates',
			routes: [ALL],
			loader: () => en_dates
		},
		{
			locale: 'fr',
			key: 'menu',
			routes: [ALL],
			loader: () => fr_menu
		},
		{
			locale: 'fr',
			key: 'gp',
			routes: [GROUPS_MANAGEMENT_PATH, ALL],
			loader: () => fr_groups
		},
		{
			locale: 'fr',
			key: 'clients',
			routes: [BACKOFFICE_PATH],
			loader: () => fr_clients
		},
		{
			locale: 'fr',
			key: 'db',
			routes: [ALL],
			loader: () => fr_database
		},
		{
			locale: 'fr',
			key: 'gpw',
			routes: [ALL],
			loader: () => fr_groups_website
		},
		{
			locale: 'fr',
			key: 'clients',
			routes: [CLIENTS_PATH],
			loader: () => fr_clients
		},
		{
			locale: 'en',
			key: 'clients',
			routes: [CLIENTS_PATH],
			loader: () => en_clients
		},
		{
			locale: 'fr',
			key: 'team',
			routes: [MY_TEAM_PATH],
			loader: () => fr_team
		},
		{
			locale: 'fr',
			key: 'mycard',
			routes: [MY_CARD_PATH, CARD_GENERATOR_PATH],
			loader: async () => fr_mycard
		},
		{
			locale: 'fr',
			key: 'jobs',
			routes: [JOBS_PATH],
			loader: async () => fr_jobs
		},
		{
			locale: 'fr',
			key: 'bsms',
			routes: [MY_SMS_PATH],
			loader: () => fr_bsms
		},
		{
			locale: 'fr',
			key: 'ohg',
			routes: [ALL],
			loader: () => fr_ohg
		},
		{
			locale: 'fr',
			key: 'bk',
			routes: [MY_BOOKINGS_PATH, CALENDAR_PATH],
			loader: () => fr_bookings
		},
		{
			locale: 'fr',
			key: 'orders',
			routes: [MY_ORDERS_PATH],
			loader: () => fr_orders
		},
		{
			locale: 'fr',
			key: 'config',
			routes: [CONFIGURATION_MESSAGES_PATH],
			loader: () => fr_configurationmessages
		},
		{
			locale: 'fr',
			key: 'qrcode',
			routes: [MY_QRCODE_PATH],
			loader: () => fr_qrcode
		},
		{
			locale: 'fr',
			key: 'inv',
			routes: [MY_INVOICES_PATH],
			loader: () => fr_invoice
		},
		{
			locale: 'fr',
			key: 'reviews',
			routes: [MY_REVIEWS_PATH],
			loader: () => fr_reviews
		},
		{
			locale: 'fr',
			key: 'gbm',
			routes: [ALL],
			loader: () => fr_groups_booking_module
		},
		{
			locale: 'en',
			key: 'gbm',
			routes: [ALL],
			loader: () => en_groups_booking_module
		},
		{
			locale: 'fr',
			key: 'mysheet',
			routes: [MY_SHEET_PATH],
			loader: () => fr_mangeznotez_sheet
		},
		{
			locale: 'fr',
			key: 'dashboard',
			routes: [DASHBOARD_PATH, ALL],
			loader: () => fr_dashboard
		},
		{
			locale: 'fr',
			key: 'stats',
			routes: [STATS_PATH],
			loader: () => fr_stats
		},
		{
			locale: 'fr',
			key: 'op',
			routes: [ONLINE_PAYMENTS_PATH],
			loader: () => fr_op
		},
		{
			locale: 'fr',
			key: 'sponsorship',
			routes: [SPONSORSHIP_PATH],
			loader: () => fr_sponsorship
		},
		{
			locale: 'fr',
			key: 'gc',
			routes: [MY_GIFTCARDS_PATH],
			loader: () => fr_giftcards
		},
		{
			locale: 'fr',
			key: 'newMobile',
			routes: [NEW_MOBILE_PATH],
			loader: () => fr_newMobile
		},
		{
			locale: 'fr',
			key: 'invoices-admin',
			routes: [ADMIN_INVOICES_PATH],
			loader: () => fr_invoices_admin
		},
		{
			locale: 'fr',
			key: 'debits',
			routes: [ADMIN_DEBITS_PATH, ADMIN_DEBITS_STATES_PATH],
			loader: () => fr_debits
		},
		{ locale: 'fr', key: 'delivery', routes: [DELIVERY_PATH], loader: () => fr_delivery },
		{ locale: 'fr', key: 'admin', routes: [ADMIN_PATH], loader: () => fr_admin },
		{
			locale: 'fr',
			key: 'cac',
			routes: [CLICK_AND_COLLECT_PATH],
			loader: () => fr_cac
		},
		{
			locale: 'fr',
			key: 'news',
			routes: [NEWS_PATH],
			loader: () => fr_news
		},
		{
			locale: 'fr',
			key: 'cri',
			routes: [RESTAURANT_INFO_PATH, COLLECT_REST_PICTURES, HUB_AFTER_SALES, AI_GENERATE_TEXT],
			loader: () => fr_collectRestInfo
		},
		{
			locale: 'fr',
			key: 'chat',
			routes: [ADMIN_CHAT_PATH],
			loader: () => fr_admin_chat
		},
		{
			locale: 'en',
			key: 'gbm',
			routes: [ALL],
			loader: () => en_groups
		},
		{
			locale: 'fr',
			key: 'booking-module',
			routes: [BOOKING_MODULE_PATH],
			loader: () => fr_booking_module
		},
		{
			locale: 'fr',
			key: 'mobile-menu',
			routes: [ALL],
			loader: () => fr_mobile_menu
		},
		{
			locale: 'fr',
			key: 'hub',
			routes: [ALL],
			loader: async () => fr_hub
		},
		{
			locale: 'fr',
			key: 'redirect',
			routes: [ALL],
			loader: async () => fr_redirect
		}
	]
};

export const { t, loading, locales, locale, initLocale, loadTranslations } = new i18n(config);
locale.set('fr');
export const currency = writable('EUR');
export const currencySymbol = writable(
	(0)
		.toLocaleString(get(locale), {
			style: 'currency',
			currency: get(currency),
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		})
		.replace(/\d/g, '')
		.trim()
);
// this will return a price with the correct currency format and won't show decimals if the price is an integer
// eg: 10.00 => 10€, 10.5 => 10,50€
export const formatPrice = (price, withDecimal = false) => {
	let fractionDigit = price % 1 ? 2 : 0;
	if (withDecimal) {
		fractionDigit = 2;
	}

	return new Intl.NumberFormat(get(locale), {
		style: 'currency',
		currency: get(currency),
		minimumFractionDigits: fractionDigit,
		maximumFractionDigits: fractionDigit
	}).format(price);
};

loading.subscribe(($loading) => $loading && console.log('Loading translations...'));
